module.exports = __webpack_public_path__ + "static/media/archive.7fbd8aeb.mp4";